import React from 'react'; 
import './Victory-Of-Light.css'; 

import '../../Button.css'; 

function VictoryOfLightMandarin() {
  window.scrollTo(0, 0);
    return (
      <>
            
          <div className="Victory-Of-Light"> 

          <form method="get" action="#/victory-of-light"> 
            <button id="the-button" type='btn'>English</button> 
          </form> 

            <h1 className="exhibition">光的光輝</h1> 
            <hr /> 

            <h6 id="head">
            組織者：
            </h6>
            <p id="points">
            亞裔美國人文化傳媒集團
            </p>
            <p id="points">
            美國龍國際美術 
            </p>

            <h6 id="head">
            承办者: 
            </h6>
            <p id="points">
            華爾街藝術空间 
            </p> 

            <h6 id="head">
            策展人： 
            </h6>
            <p id="points">
            Lena Liu 刘伟
            </p>
            <p id="points">
            Apelles Zhou 
            </p> 
            <br></br>

            <h2 id="header-thing">
            2020年2月8日開幕招待會;下午3:30 
              </h2> 
              <p id="art-paragraph-other">
              來自9個國家/地區的15位藝術家將展示他們的引人入勝的照片，繪畫以及裝置/雕塑藝術作品，這些作品將被納入下一個展覽，
              即2020年國際光影藝術展覽。該展覽將於2020年2月8日至2020年3月9日。在這次華爾街藝術空間展覽期間，地球將過渡到水瓶座時代。 
              </p> 
              <p id="art-paragraph-other">
              由於這兩個機構的合併，包括文化教育中心和美術館，亞裔美國人文化傳媒集團和美國龍國際美術有限公司取得了巨大的成功。
              我們使用這種商業模式來補充經濟和文化優勢。我們在華爾街和三位一體上的完美地理位置可以代表物質和精神上的和諧。
              我們的一些客戶來自金融行業，包括史蒂芬·洛克菲勒先生。這些客戶會定期參加以支持我們的藝術展覽，
              並且我們已經從這個社交圈中培養了一大批收藏家。 
              </p> 
              <p id="art-paragraph-other">
              在2020年2月8日（星期六）的開幕酒會上，我們將舉辦一場音樂會，以使該活動與我們的文化價值觀進一步融合，
              並幫助吸引更多的客戶和收藏家。展覽將展出40位來自才華橫溢的藝術家的作品。 
              </p> 
              <br /> 

              <img src="./Vol1.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">Oil on Canvas</h5> 
              <h5 id="caption-thing">29" x 50"</h5> 
              <h5 id="caption-thing">$7,300.00</h5> 
              <h5 id="caption-thing">Aparna Banerjee</h5> 
              <br /> 

              <img src="./Vol2.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">The Age of Aquarius</h5> 
              <h5 id="caption-thing">Oil and Acrylic on Canvas</h5> 
              <h5 id="caption-thing">18" x 24"</h5> 
              <h5 id="caption-thing">$1,500.00</h5> 
              <h5 id="caption-thing">Apelles Zhou</h5> 
              <br /> 

              <img src="./Vol3.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">Through the Picture</h5> 
              <h5 id="caption-thing">Oil on Canvas</h5> 
              <h5 id="caption-thing">39" x 39"</h5> 
              <h5 id="caption-thing">$10,000.00</h5> 
              <h5 id="caption-thing">Rosana Largo Rodriguez</h5> 
              <br /> 

              <img src="./Vol4.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">Sky Dust</h5> 
              <h5 id="caption-thing">Hand Jacquard Woven Cotton, Hand Dyed Kid Mohair, Silk, Metallic, Plastic, and Holographic Yarns</h5> 
              <h5 id="caption-thing">18" x 21" x 1"</h5> 
              <h5 id="caption-thing">$3,500.00</h5> 
              <h5 id="caption-thing">Robin Kang</h5> 
              <br /> 

              <img src="./Vol5.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">Paint Can Mouse</h5> 
              <h5 id="caption-thing">Acrylic on Wood Panel</h5> 
              <h5 id="caption-thing">36" x 48"</h5> 
              <h5 id="caption-thing">$4,000.00</h5> 
              <h5 id="caption-thing">Pitch Blac</h5> 
              <br /> 

              <img src="./Vol6.jpeg" id="image-thing"></img> 
              <h5 id="caption-thing">Offerings</h5> 
              <h5 id="caption-thing">Oil on Canvas</h5> 
              <h5 id="caption-thing">30" x 30"</h5> 
              <h5 id="caption-thing">$1,600.00</h5> 
              <h5 id="caption-thing">Imaing Clyde</h5> 
              <br /> 

              <img src="./Vol7.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">Silver Water</h5> 
              <h5 id="caption-thing">Mixed Media Paper, Ink, Heavy Gloss Acrylic Varnish, Glass, Wood Framing</h5> 
              <h5 id="caption-thing">13” x 16” X 0.75"</h5> 
              <h5 id="caption-thing">$975.00</h5> 
              <h5 id="caption-thing">Denise Cummings</h5> 
              <br /> 

              <img src="./Vol8.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">Full Moon II</h5> 
              <h5 id="caption-thing">Acrylic on Panel</h5> 
              <h5 id="caption-thing">24" x 18"</h5> 
              <h5 id="caption-thing">$1,800.00</h5> 
              <h5 id="caption-thing">Calli Moore</h5> 
              <br /> 

              <img src="./Vol9.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">Travel Around the World Dreaming</h5> 
              <h5 id="caption-thing">Mixed Media on Paper</h5> 
              <h5 id="caption-thing">28" x 32"</h5> 
              <h5 id="caption-thing">$2,900.00</h5> 
              <h5 id="caption-thing">Hyelim Chang</h5> 
              <br /> 

              <img src="./Vol10.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">Acrylic on Canvas</h5> 
              <h5 id="caption-thing">36" x 35"</h5> 
              <h5 id="caption-thing">$4,500.00</h5> 
              <h5 id="caption-thing">Chadwick</h5> 
              <br /> 

              <img src="./Vol11.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">12 Arch Angels of The Central Sun</h5> 
              <h5 id="caption-thing">Oil on Canvas</h5> 
              <h5 id="caption-thing">48" x 48"</h5> 
              <h5 id="caption-thing">$5,000.00</h5> 
              <h5 id="caption-thing">Ryan Michael Ford</h5> 
              <br /> 

              <img src="./Vol12.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">The Light of My Life</h5> 
              <h5 id="caption-thing">Acrylic on Canvas</h5> 
              <h5 id="caption-thing">30" x 30"</h5> 
              <h5 id="caption-thing">$2,499.00</h5> 
              <h5 id="caption-thing">Barbara Muir</h5> 
              <br /> 

              <img src="./Vol13.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">A Mouthful</h5> 
              <h5 id="caption-thing">Mixed Media Paper, Ink, Heavy Gloss Acrylic Varnish, Glass, Wood Framing</h5> 
              <h5 id="caption-thing">12” x 15” x 0.75”</h5> 
              <h5 id="caption-thing">$775.00</h5> 
              <h5 id="caption-thing">Denise Cummings</h5> 
              <br /> 

              <img src="./Vol14.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">L'uccello Maria</h5> 
              <h5 id="caption-thing">Textured Acrylic on Unframed Stretched Canvas</h5> 
              <h5 id="caption-thing">24" x 30"</h5> 
              <h5 id="caption-thing">$3,000.00</h5> 
              <h5 id="caption-thing">Lightning Yumeku</h5> 
              <br /> 
              
          </div>
        </> 
    );
  }
  
  export default VictoryOfLightMandarin;